import Model from "~/models/_Model";
import dayjs from "dayjs";

export default class WatchlistStudent extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile/watchlist";
  }

  // Set the resource route of the model
  resource() {
    return "students";
  }

  relations() {
    return {
      //student: Student,
    };
  }

  primaryKey() {
    return "STUDENT_ID";
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
  // Computed Attributes
  get building_name() {
    if (this.building && this.building.NAME) {
      return this.building.NAME;
    }
    switch (this.BUILDING) {
      case "100":
      case 100:
        return "East Leyden High School";
      case "200":
      case 200:
        return "West Leyden High School";
      case "300":
      case 300:
        return "LIFE Program";
      default:
        return `Building: ${this.BUILDING}`;
    }
  }

  get display_birthdate_age() {
    return `${this.display_birthdate} (${this.display_age})`;
  }

  get display_birthdate() {
    return dayjs(this.BIRTHDATE).format("MM/DD/YYYY");
  }

  get display_age() {
    return dayjs(this.BIRTHDATE).toNow(true);
  }

  get display_student_grade() {
    if (!this.academic) {
      return this.GRADE;
    }

    return `${this.GRADE} (${this.academic.GRADUATION_YEAR})`;
  }

  get display_dean_name() {
    if (!this.academic || !this.academic.dean) {
      return "None";
    }
    return this.academic.dean.display_name || "None";
  }

  get display_houseteam_name() {
    if (!this.house_team_info) {
      return "None";
    }
    return this.house_team_info.DESCRIPTION || "None";
  }

  get display_counselor_name() {
    if (!this.counselor_info) {
      return "None";
    }
    return this.counselor_info.display_name || "None";
  }

  get display_class_of() {
    if (!this.academic) {
      return "Not Loaded";
    }
    return this.academic.GRADUATION_YEAR || "None";
  }

  get display_locker_number() {
    if (!this.personal) {
      return "Not Loaded";
    }
    return this.personal.LOCKER_NUMBER || "None";
  }
}
